import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import BlockRenderer from '../blocks/BlockRenderer';

const Column = ({ column, rowId, isPreview = false, idPrefix = '', scale = 1 }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `${idPrefix}${column.id}`,
    data: { type: 'column', rowId, originalId: column.id }
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex-1 min-h-[50px] transition-colors ${!isPreview ? 'p-2' : ''} ${isOver ? 'bg-indigo-50/10' : ''}`}
    >
      <SortableContext
        items={column.blocks.map(b => `${idPrefix}${b.id}`)}
        strategy={verticalListSortingStrategy}
      >
        {column.blocks.map((block, index) => (
          <BlockRenderer 
            key={block.id} 
            block={block} 
            columnId={column.id} 
            index={index} 
            isPreview={isPreview} 
            idPrefix={idPrefix}
            scale={scale}
          />
        ))}
        {column.blocks.length === 0 && (!isPreview || isOver) && (
          <div className={`h-full min-h-[100px] border-2 border-dashed border-slate-200 rounded-lg flex items-center justify-center text-slate-400 text-sm italic ${isPreview ? 'scale-75' : ''}`}>
            Drop blocks here
          </div>
        )}
      </SortableContext>
    </div>
  );
};

export default Column;
